import { useCallback } from "react";

import {
  enqueueLaborAmendPersist,
  type EnqueueLaborAmendPersistCallOptions,
} from "@/encounters/components/EncounterLabor/utils/enqueue-labor-amend-persist";
import { useLaborAmendFlowsheetPersist } from "@/encounters/contexts/LaborAmendFlowsheetPersistContext";

/**
 * Returns a function that enqueues deferred labor-amend flowsheet persists with shared context
 * fields from `LaborAmendFlowsheetPersistProvider`.
 */
export function useEnqueueLaborAmendPersist() {
  const {
    deferFlowsheetPersists,
    isFlowsheetEditingEnabled,
    laborStagesLoadStatus,
    birthObservationsLoadStatus,
    isFlowsheetPersistLocked,
    enqueueFlowsheetPersist,
    registerPendingDisplayEntry,
    setObservationPreviewPatch,
  } = useLaborAmendFlowsheetPersist();

  return useCallback(
    (options: EnqueueLaborAmendPersistCallOptions) =>
      enqueueLaborAmendPersist({
        deferFlowsheetPersists,
        isFlowsheetEditingEnabled,
        laborStagesLoadStatus,
        birthObservationsLoadStatus,
        isFlowsheetPersistLocked,
        enqueueFlowsheetPersist,
        registerPendingDisplayEntry,
        setObservationPreviewPatch,
        ...options,
      }),
    [
      birthObservationsLoadStatus,
      deferFlowsheetPersists,
      enqueueFlowsheetPersist,
      isFlowsheetEditingEnabled,
      isFlowsheetPersistLocked,
      laborStagesLoadStatus,
      registerPendingDisplayEntry,
      setObservationPreviewPatch,
    ],
  );
}
